<template>
  <div id="ordering-order-basic-info">
    <div class="basic-info-product-info">
      <div class="basic-info-product-info-top">
        <img :src="order.national_flag_img" alt="" class="icon-flag">
        <router-link :to="goProduct()" target="_blank" class="product-link">{{order.product_name}}</router-link>
      </div>
      <div class="basic-info-product-info-bottom">
        <div class="basic-info-product-info-bottom-item">
          <div class="basic-info-product-info-bottom-item-label">
            入境次数
          </div>
          <div class="basic-info-product-info-bottom-item-value" v-if="product && product.common_info">
            <span class="item-value" v-if="product.common_info[2].type === 0">{{product.common_info[2].num}}{{product.common_info[2].unit}}</span>
            <span class="item-value" v-else>{{product.common_info[2].unit}}</span>
          </div>
        </div>
        <div class="basic-info-product-info-bottom-item">
          <div class="basic-info-product-info-bottom-item-label">
            有效期
          </div>
          <div class="basic-info-product-info-bottom-item-value" v-if="product && product.common_info">
            <span v-if="product.common_info[0].type === 0">{{ product.common_info[0].num }}{{ product.common_info[0].unit }}</span>
            <span v-else>{{ product.common_info[0].unit }}{{ product.common_info[0].memo ? `，${product.common_info[0].memo}` : '' }}</span>
          </div>
        </div>
      </div>
      
    </div>
    <div class="basic-info-depart-date">
      <div class="depart-date-label">
        <img class="icon" src="https://o.666visa.cn/static/ssqpeer/common/icon_date.png" alt="">
        <div class="text">预计出行日期</div>
      </div>
      <div class="depart-date-content">
        <holiday-date-picker
          style="width: 240px;"
          :depart-date="new Date(order.depart_date)"
          v-bind:min-disabled-date="disabledDate"
          :holiday-date-arr="holidayArr"
          :selected-display-none="true"
          :show-early="true"
          v-on:input="changeDepartDate">
        </holiday-date-picker>
      </div>
    </div>
    <div class="basic-info-user" v-if="order.peer_user && order.peer_user.mobile_phone">
      顾客电话: {{order.peer_user.mobile_phone}}
    </div>
  </div>
</template>

<script>
import holidayDatePicker from '../../../components/holiday-date-picker';
import orderingService from '../../../services/ordering-service';
import addNewOrderService from '../../../services/add-new-order-service';
import orderComfirmService from '../../../services/order-comfirm-service';
import sensorService from '../../../services/sensor-service';
import Http from '@/libs/http';

export default {
  name: 'ordering-order-basic-info',
  props: {
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    from: {
      type: String,
      default: 'order_upload',
    },
  },
  data() {
    return {
      holidayArr: [], // 处理国的放假日期
      holidays: [], // 国家放假日历原始数据
      disabledDate: '', // 不可用日期
      depart_date_object: '',
      product: {},
    };
  },
  computed: {
  },
  components: {
    holidayDatePicker,
  },
  created() {
    this.getProductInfo();
    this.getCountryHoliday();
  },
  methods: {
    addApplicant() {
      this.$emit('addApplicant');
    },
    // 改变出行日期
    changeDepartDate(date) {
      this.$emit('changeDepartDate', date.format('yyyy-MM-dd'));
      orderingService.updateOrderDepartDate(this.order).then(() => {
        this.$message({
          message: '修改成功',
          type: 'success',
        });
        this.$emit('changeDepartDate', date.format('yyyy-MM-dd'));
      });
    },
    // 获取国家放假信息
    getCountryHoliday() {
      orderingService.countryHolidayQuery(this.order.visa_country_id).then((data) => {
        if (!Object.keys(data).length) return;

        // 放假信息
        this.holidays = data[Object.keys(data)[0]];

        // 不可用日期
        this.disabledDate = addNewOrderService.handleDisabledDate(this.order.earliest_depart_date);

        // 格式化给出行日期选择项用
        this.holidayArr = orderComfirmService.formatHoliday(this.holidays, this.disabledDate);

      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 获取商品信息
    async getProductInfo() {
      this.product = await Http.post('/visa_product_query', { visa_product_id: this.order.visa_product_id });
    },
    // 获取路由跳转地址
    goProduct() {
      const pageFrom = sensorService.getPageFrom('订单页');
      return { name: 'product', params: { visa_product_id: this.order.visa_product_id }, query: { from: this.from, ...pageFrom } };
    },
  },
};
</script>

<style lang="less" scoped>
#ordering-order-basic-info {
  line-height: 1;
  font-size:16px;
  color: #333;
  .basic-info-product-info{
     margin-top: 10px;
      width: 100%;
      // height: 107px;
      padding:0 30px;
      background-color: #fff;
    .basic-info-product-info-top{
      height: 60px;
      border-bottom: 1px solid #E9EEF2;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      .icon-flag{
        width: 24px;
        height: 20px;
        display: block;
        border-radius: 4px;
      }
      .product-link{
        font-size: 16px;
        color: #2F333D;
        font-weight: 500;
      }
    }
    .basic-info-product-info-bottom{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 46px;
      align-items: center;
      gap: 32px;
      padding-left: 34px;
      .basic-info-product-info-bottom-item{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        font-size: 14px;
        .basic-info-product-info-bottom-item-label{
          color: #91999F;
        }
        .basic-info-product-info-bottom-item-value{
          color: #2F333D;
          font-weight: 400;
        }
      }
    }

  
  }

  .basic-info-depart-date{
    display: flex;
    align-items: center;
    margin-top: 10px;
    background: #fff;
    padding: 30px;
    gap: 20px;
    .depart-date-label{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      .icon{
        display: block;
        width: 16px;
        height: 16px;
      }
      .text{
        font-weight: 400;
        font-size: 16px;
        color: #2F333D;
      }
    }
  }
  .basic-info-user{
    margin-top: 20px;
  }
  .add-applicant {
    background-color: #ffffff;
    font-size: 14px;
    color: #5e9be1;
    width: 134px;
    height: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/ordering-order-basic-info.vue